import type { FinanceHolding, InvestmentWeekHistory } from "./financeConnections";
export function isCashHolding(holding: Pick<FinanceHolding,"securityType"|"isCashEquivalent">) {
  const type = String(holding.securityType || "").toLowerCase().replace(/[ -]/g,"_");
  return holding.isCashEquivalent === true || ["cash","cash_equivalent","money_market","sweep"].includes(type);
}
export function investmentWeekOf(date = new Date()) {
  const day = new Intl.DateTimeFormat("en-CA",{timeZone:"America/New_York",year:"numeric",month:"2-digit",day:"2-digit"}).format(date);
  const monday = new Date(day+"T12:00:00Z");
  monday.setUTCDate(monday.getUTCDate()-(monday.getUTCDay()+6)%7);
  return monday.toISOString().slice(0,10);
}
export function summarizeWeek(rows:FinanceHolding[],week=investmentWeekOf()) {
  let opening=0,current=0,missing=0;
  const positions=rows.filter(row=>!isCashHolding(row));
  for(const row of positions){
    const quantity=Number(row.quantity),price=Number(row.marketPrice??row.institutionPrice),start=Number(row.mondayOpeningPrice);
    if(![quantity,price,start].every(Number.isFinite)||price<=0||start<=0||row.mondayWeekOf!==week||row.mondayOpeningSource!=="market_open"){missing++;continue;}
    opening+=quantity*start;current+=quantity*price;
  }
  return {opening,current,missing,positions:positions.length,change:current-opening};
}
export function summarizeWeekHistory(rows:InvestmentWeekHistory[]) {
  const verified=rows.filter(row=>row.method==="current-holdings-price-v2"&&row.complete===true&&row.change!=null);
  return {change:verified.reduce((sum,row)=>sum+Number(row.change),0),count:verified.length};
}
